import { makeStyles, Theme } from '@material-ui/core/styles';

const styles = makeStyles(({ palette,variables }: Theme) => ({
    jetStatusBadge:{
        borderRadius: variables?.radiusRoundedA,
        padding: `${variables?.radiusRoundedNone} ${variables?.radiusRoundedA}` ,
        color: palette.jet?.containerDefault,
        display: 'inline-block',
        '&.inverse': {
          backgroundColor: palette.jet?.supportPositiveInverse
        },
        '&.action': {
          backgroundColor: palette.jet?.containerDark
        },
        '&.default': {
          backgroundColor:palette?.jet?.supportNeutral,
        },
        '&.returning': {
          backgroundColor:palette?.jet?.supportBrand06,
        },
        '&.invitation': {
          backgroundColor: palette.jet?.supportPositive02,
          color: palette.jet?.contentDefault,
          borderRadius: variables?.radiusRoundedB,
          padding:`2px ${variables?.spacingB}`
        },
        '&.disconnect': {
          backgroundColor: palette.jet?.supportError02,
          color: palette.jet?.contentDefault,
          borderRadius: variables?.radiusRoundedB,
          padding:`2px ${variables?.spacingB}` 
        }
    }
}))

export default styles